import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Item, Order} from '../models/order.model';
import {RoomType} from '../models/roomType.model';
import {CheckIn} from '../models/checkin.model';
import {EMPTY, forkJoin, Observable, of} from 'rxjs';
import {catchError, map, switchMap} from "rxjs/operators";
import { timer } from 'rxjs';
import {ReservationService} from "./reservation.service";
import { StatementFilters } from '../models/reconciliation.models';
import { CustomerOverview, ReceptionPlanning } from '../models/KpiByUser.model';


export interface DocType {
  docTypeId: number;
  name: string;
  nameEn: string | null;
}

export interface AccountEntrySearchParams {
  accountLogId: number;
  from: string;
  to: string;
  debitOrCredit: 'debit' | 'credit';
  reference?: string;
}

export interface AccountEntryDto {
  entryId: number;
  account?: any;
  credit?: number | null;
  debit?: number | null;
  reference?: string | null;
  reconciliationCode?: string | null;
  billingNumber?: string | null;
  created?: string | null;
  creationDate?: string | null;
  operationDate?: string | null;
  [key: string]: any;
}

export interface NewReconciliationPayload {
  accountingEntryIds: number[];
  reconciliationCode: string;
  billingNumber?: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class CheckInService {
  saveGuarantee(payload: { accountId: any; type: any; name: any; detail: any; amount: any; currency: any; valid: any; creationDate: string; }) {
    throw new Error('Method not implemented.');
  }
    guestFilter:any = undefined;
    numberFilter:any = undefined;
    numberAgenceFilter:any = undefined;
    reservationStatusFilter:any =undefined;
    customerFilter:any=undefined;
    segmentsFilter:any = undefined;
    segement:any = undefined;
    SentBavel:any = undefined;
    checkinDate:any= undefined;
    checkoutDate:any = undefined;
    cancelldFromDate:any = undefined;
    cancelledToDate:any = undefined;
    createdDate : any = undefined ;
    createdDateV2 :any = undefined;
    convertedDateCre: Date = undefined;
    convertedDateCreV2: Date = undefined;
    userSleced:any = 0;
    DueOut:boolean = false;
    public apiCheckIn:string = environment.api+'/checkins';
    public api:string = environment.api+'/orders';
    private createrese = environment.api+ "/reservations"
    // public url:string = environment.apiCheckinData+'/orders';
    // public crmurl:string = 'https://crmapi.valeriahotels.com/api/orders?type=Customer&group=0&createdfrom=2021-05-15&createdto=2022-11-16';
    public crmurl:string = environment.api+'/reservations?';
    public reservationService:string = environment.api+'/reservations';
    public crmApi:string = environment.crmTest;
    reservationServiceV2: string = environment.api +'/reservations/v2';


    private itemUrl:string = environment.crmTest + '/item';
    private itemOrderUrl:string = environment.crmTest +'/order/item';
    private itemOrderUrlOrder:string = environment.crmTest +'/order';
    private invoiceurl:string = environment.crmTest + '/allinvoices/v2?';
    private invoiceurlDownlad:string = environment.crmTest + '/allinvoices/export?';
    ExportUrlV1: string;
   

    // public crmUrl:string = "https://crmapi.valeriahotels.com/api/orders?type=Customer&group=0"

    constructor(private http: HttpClient) { }
    getPayment(From:any,To:any,user?:any){

        let url = environment.crmTest +'/payments?group='+ JSON.parse(localStorage.getItem("userDetails")).group.groupId ;

        if(From !== undefined && From !== null){
            url = url+'&createdfrom='+From;
        }
        if(To !== undefined && To !== null){
            url = url+'&createdto='+To;
        }
        if(user !== undefined && user !== null){
            url = url+'&user='+user;
        }

        return this.http.get(url);
    }

    // NEW METHOD: Get payments by datetime range (closing time logic)
    getPaymentByTime(createdFrom: string, createdTo: string, user?: any) {
        let url = environment.crmTest + '/payments/bytime?group=' + JSON.parse(localStorage.getItem("userDetails")).group.groupId;

        if (createdFrom !== undefined && createdFrom !== null) {
            url = url + '&createdfrom=' + createdFrom;
        }
        if (createdTo !== undefined && createdTo !== null) {
            url = url + '&createdto=' + createdTo;
        }
        if (user !== undefined && user !== null) {
            url = url + '&user=' + user;
        }

        return this.http.get(url);
    }

    getPaymentForCMI(From:any,To:any,user?:any){
        const mygrp = JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        const grp = (mygrp == 1 ||  mygrp == 2) ? 0 : mygrp;
        if(grp == 0){

        }
        let url = environment.crmTest +'/payments?group='+ grp ;

        if(From !== undefined && From !== null){
            url = url+'&createdfrom='+From;
        }
        if(To !== undefined && To !== null){
            url = url+'&createdto='+To;
        }
        if(user !== undefined && user !== null){
            url = url+'&user='+user;
        }

        return this.http.get(url);
    }

    // Dans check-in.service.ts
getAllCustomersWithoutPagination(filter: string, type: number, group: number) {
    return this.http.get<any>(`/api/customers?size=10000&filter=${filter}&type=${type}&group=${group}`);
  }
  
//    getCustomers(page: number, guest: string, type: number, group: number): Observable<any> {
//     let baseUrl = environment.crmTest;

//     if (type === 0) {
//         baseUrl += '/legals'; // Morale
//     } else {
//         baseUrl += '/customers'; // Physique
//     }

//     if (guest.trim() !== '') {
//         baseUrl += `?page=${page}&group=${group}&criteria=${guest}`;
//     } else {
//         baseUrl += `?page=${page}&group=${group}`;
//     }

//     return this.http.get(baseUrl);
//    }

getCustomers(page: number, guest: string, type: number, group: number, size: number): Observable<any> {
    let baseUrl = environment.crmTest;
  
    // Choix de l'endpoint selon type
    baseUrl += (type === 0) ? '/legals' : '/customers';
  
    // Construction sécurisée des paramètres
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('group', group.toString());
    params.append('size', size.toString());
  
    if (guest && guest.trim() !== '') {
      params.append('criteria', guest.trim());
    }
  
    const fullUrl = `${baseUrl}?${params.toString()}`;
  
    return this.http.get(fullUrl);
  }
  



  updateClient(client: any): Observable<any> {
    let url: string;

    // 1. Cas Personne Physique (NATURAL) -> Modifie firstName / lastName
    if (client.personType === 'NATURAL' || client.personType === 'Physique') {
        // L'URL cible les personnes physiques
        url = `${environment.crmTest}/naturalpersons/${client.id}`;
        
        // Note : Le backend s'attend généralement à recevoir "firstName" et "lastName"
        // Assurez-vous que l'objet 'client' contient bien ces champs modifiés par votre formulaire.
    } 
    // 2. Cas Personne Morale (LEGAL)
    else {
        // Logique spécifique pour mapper le nom si nécessaire
        if (client.socialReason) {
             client.name = client.socialReason;
        }
        url = `${environment.crmTest}/legalpersons/${client.id}`;
    }

    return this.http.put<any>(url, client, { observe: 'response' });
  }

  createCustomer(client: any): Observable<any> {
    let url: string;

    // 1. Cas Personne Physique (NATURAL ou PHYSICAL)
    // On vérifie les deux cas au cas où votre select envoie 'PHYSICAL'
    if (client.personType === 'NATURAL' || client.personType === 'LEGAL') {
      
      url = `${environment.crmTest}/naturalpersons`;
      
    } 
    // 2. Cas Personne Morale (LEGAL)
    else {
      
      url = `${environment.crmTest}/legalpersons`;

      // Logique pour s'assurer que socialReason est rempli pour le backend
      // (Si le formulaire a rempli 'name', on le copie dans 'socialReason')
      if (client.name && !client.socialReason) {
        client.socialReason = client.name;
      }
    }

    // Envoi de la requête POST
    return this.http.post<any>(url, client);
  }
   getCustomers1(
    page: number,
    guest: string,
    type: number,
    group: number,
    creationDate?: string // 🆕 paramètre optionnel
  ): Observable<any> {
    let baseUrl = environment.crmTest;
    baseUrl += type === 0 ? '/legals' : '/customers';
  
    const params: string[] = [`page=${page}`, `group=${group}`];
  
    if (guest.trim()) {
      params.push(`criteria=${encodeURIComponent(guest)}`);
    }
  
    if (creationDate) {
      params.push(`creationDate=${creationDate}`);
    }
  
    baseUrl += '?' + params.join('&');
  
    return this.http.get(baseUrl);
  }
  

   getCustomerById(id: number, group: number): Observable<any> {
    let baseUrl = environment.crmTest +`/persons/${id}?group=${group}`
    return this.http.get<any>(baseUrl);
   }

//    https://crmapi.valeriahotels.com/api/orders/v2?page=0&type=Customer&customer=489343&group=2

//    getOrdersByCustomer(supplierId: number, group: number, page: number = 0, size: number = 20): Observable<any> {
//     const url = `${environment.crmTest}/orders/v2?page=${page}&type=Customer&customer=${supplierId}&group=${group}`;
//     return this.http.get<any>(url);
//    }

getOrdersByCustomer(
    supplierId: number, 
    group: number, 
    page: number = 0, 
    size: number = 20, 
    from?: string, // ✅ Nouveau paramètre
    to?: string    // ✅ Nouveau paramètre
  ): Observable<any> {
      
      // URL de base
      let url = `${environment.crmTest}/orders/v2?page=${page}&size=${size}&type=Customer&customer=${supplierId}&group=${group}`;
      
      // ✅ Ajout dynamique des dates si elles existent
      if (from) {
        url += `&createdfrom=${from}`;
      }
      if (to) {
        url += `&createdto=${to}`;
      }
  
      return this.http.get<any>(url);
  }




//   getStatementEntries(customerId: number, groupId: number, from: string, to: string, isReconciliated: boolean = false, number?: string): Observable<any[]> {
//     let url = `${environment.crmTest}/statement/entries?customerId=${customerId}&groupId=${groupId}&from=${from}&to=${to}&isReconciliated=${isReconciliated}`;
    
//     // ✅ Ajout du filtre par numéro s'il est renseigné
//     if (number) {
//       url += `&number=${number}`;
//     }
    
//     return this.http.get<any[]>(url);
//   }





 
  getStatementEntries1(
    customerId: number, 
    groupId: number | null, // ✅ Accepte null maintenant
  
    number?: string, 
    search?: string
  ): Observable<any[]> {
      
      // 1. URL de base SANS le groupId
      let url = `${environment.crmTest}/statement/entries?customerId=${customerId}`;
      
      // 2. ✅ On ajoute groupId SEULEMENT s'il est défini (pas null, pas 0)
      if (groupId) {
        url += `&groupId=${groupId}`;
      }
  
      // 3. Autres filtres
      if (number) {
        url += `&number=${number}`;
      } 
  
      if (search) {
        url += `&search=${search}`; 
      }
      
      return this.http.get<any[]>(url);
  }




// getStatementEntries(customerId: number, groupId: number, from: string, to: string, isReconciliated: boolean = false): Observable<any[]> {
//     const url = `${environment.crmTest}/statement/entries?customerId=${customerId}&groupId=${groupId}&from=${from}&to=${to}&isReconciliated=${isReconciliated}`;
//     return this.http.get<any[]>(url);
//   }





// getAccountingEntries(customerId: number, groupId: number, from: string, to: string): Observable<any[]> {
//     // Construction de l'URL avec les paramètres
//     const url = `${environment.crmTest}/reconciliation/total/search?customerId=${customerId}&groupId=${groupId}&from=${from}&to=${to}`;
//     return this.http.get<any[]>(url);
//   }




  
   getPersonStatsUpdate(personId: number): Observable<any> {
    return this.http.get<any>(`${environment.crmTest}/person/stats/update/${personId}`);
  }
  
  // check-in.service.ts (ou customer.service.ts)
  getEMessagesByPerson(personId: number, page = 0, size = 20) {
    return this.http.get<any>(`${environment.crmTest}/emessages?personId=${personId}&page=${page}&size=${size}`);
  }
  
  getQuotesByCustomer(customerId: number, group: number, page = 0, size = 10) {
    return this.http.get<any>(
      `${environment.crmTest}/orders/v2?page=${page}&size=${size}&type=Quote&customer=${customerId}&group=${group}`
    );
  }

  addAccountToPerson(personId: number, payload: any) {
    return this.http.post(
      `${environment.crmTest}/persons/${personId}/accounts`,
      payload
    );
  }

  getAccounts(personId: number): Observable<any> {
    return this.http.get<any>(`${environment.crmTest}/persons/${personId}/accounts`);
  }

  createAccount(personId: number, payload: any): Observable<any> {
    return this.http.post<any>(`${environment.crmTest}/persons/${personId}/accounts`, payload);
  }

  createAccountingAccount(payload: { officialCode: string; type: number; name: string }): Observable<any> {
  return this.http.post<any>(`${environment.crmTest}/account`, payload);
}

  updateAccount(personId: number, payload: any) {
    return this.http.post(
      `${environment.crmTest}/persons/${personId}/accounts/update`,
      payload
    );
  }
  // check-in.service.ts

addGuaranteeToPersonAccount(personId: number, accountId: number, guarantee: any): Observable<any> {
    // POST /persons/{pid}/accounts/{aid}/guarantees
    const url = `${environment.crmTest}/persons/${personId}/accounts/${accountId}/guarantees`;
    return this.http.post<any>(url, guarantee);
  }
  
  disableAccount(personId: number, accountId: number): Observable<any> {
    const url = `${environment.crmTest}/persons/${personId}/accounts/${accountId}/disable`;
    return this.http.post(url, {});
  }
  



// 1. Pour LIRE la liste (GET) -> C'est le lien que vous m'avez montré
getPaymentsByCustomer(customerId: number, groupId: number, from: string, to: string) {
    let params = new HttpParams()
      .set('customer', customerId.toString())
      .set('group', groupId.toString())
      .set('createdfrom', from)
      .set('createdto', to);
  
    return this.http.get<any[]>(`${environment.crmTest}/payments/bycustomer`, { params });
  }
  




// GET /persons/{personId}/accounts/{accountId}/payments
getPaymentsByAccount(personId: number, accountId: number, start: string, end: string): Observable<any[]> {
    // Assuming the endpoint supports date filtering via query params
    // If not, remove the params.
    const url = `${environment.crmTest}/persons/${personId}/accounts/${accountId}/payments`;
    
    // Note: Check if your API uses 'dateFrom'/'dateTo' or 'createdFrom'/'createdTo'
    // Based on your screenshots, it seems to be ?createdfrom=...&createdto=...
    let params = new HttpParams()
      .set('createdfrom', start)
      .set('createdto', end);
  
    return this.http.get<any[]>(url, { params });
  }
  
addPaymentToPersonAccount(personId: number, accountId: number, payment: any): Observable<any> {
    // L'URL contient les IDs, le body (payment) ne contient que {amount, currency, status}
    const url = `${environment.crmTest}/persons/${personId}/accounts/${accountId}/payments`;
    return this.http.post<any>(url, payment);
  }


  PostPaymentToPersone(payment:any): Observable<any>{
    const url = `${environment.crmTest}/accountentry/payment`;
    return this.http.post<any>(url, payment);
  }



  // Ajoutez cette méthode dans votre CheckInService
getPaymentMethods() {
    return this.http.get<any[]>(`${environment.crmTest}/paymentmethods`);
  }


updatePayment(personId: number, accountId: number, paymentId: number, payload: any) {
    // L'URL correspond à votre structure : /persons/{pId}/accounts/{accId}/payments/{payId}
    return this.http.put<void>(
      `${environment.crmTest}/persons/${personId}/accounts/${accountId}/payments/${paymentId}`,
      payload
    );
  }

// Modification : on passe accountId au lieu de customerId
getUnallocatedPayments(accountId: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.crmTest}/reconciliation/payments/unallocated/account/${accountId}`);
  }

//   getUnreconciledInvoices(customerId: number): Observable<any[]> {
//     return this.http.get<any[]>(`${environment.crmTest}/reconciliation/invoices/unreconciled/${customerId}`);
//   }

  // Historique des lettrages
  getAllocationsByCustomer(customerId: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.crmTest}/reconciliation/allocations/customer/${customerId}/all`);
  }



// getUnreconciledInvoices(customerId: number, from?: string, to?: string): Observable<any[]> {
//     // ✅ CORRECTION : Ajout de group=1 et status=Validated (souvent requis)
//     let url = `${environment.crmTest}/allinvoices/v2?group=1&customer=${customerId}`;
  
//     // Ajout des dates si elles sont fournies
//     if (from) {
//       url += `&createdfrom=${from}`;
//     }
//     if (to) {
//       url += `&createdto=${to}`;
//     }
  
//     return this.http.get<any[]>(url);
//   }

// check-in.service.ts

getUnreconciledInvoices(customerId: number, from?: string, to?: string, group: number = 1): Observable<any[]> {
    // ✅ DYNAMIQUE : on utilise la variable ${group} au lieu de 1 en dur
    let url = `${environment.crmTest}/allinvoices/v2?group=${group}&customer=${customerId}`;
  
    // Ajout des dates si elles sont fournies
    if (from) {
      url += `&createdfrom=${from}`;
    }
    if (to) {
      url += `&createdto=${to}`;
    }
  
    return this.http.get<any[]>(url);
  }
  


   getInvoicesByCustomer(id: number, page: number) {
    // https://crmapi.valeriahotels.com/api//invoice/person/63064?page=0

    const url = `${environment.crmTest}/invoice/person/${id}?page=${page}`;
    return this.http.get<any>(url);
    }

    getPaymentBytime(From:any,To:any,user?:any){
        let url = environment.crmTest +'/payments/bytime?group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        if(From !== undefined && From !== null){
            url = url+'&createdfrom='+From;
            // url = url+'&createdfrom=2024-11-01T00:00:00';

        }
        if(To !== undefined && To !== null){
            url = url+'&createdto='+To;
        }
        if(user !== undefined && user !== null){
            url = url+'&user='+user;
        }

        return this.http.get(url);
    }
    getCommandeLeutreage(From:any,To:any,client:any){
        let url = environment.crmTest+'/orders/v2?page=0&type=Customer&group=0';
        if(From !== undefined && From !== null){
            url = url+'&createdfrom='+From;
        }
        if(To !== undefined && To !== null){
            url = url+'&createdto='+To;
        }
        if(client !== undefined && client !== null){
            url = url+'&customer='+client.id;
        }

        return this.http.get(url);
    }
    // getAllSegments():Observable<any>{
    //     let url = environment.crmTest + '/segments'; 
    //     return this.http.get(url);
    // }
    getAllCheckins(index:number, size:number){
        const body = {
            //'url': this.url+'page='+index+'&type=Customer&producttype=1',
            'status':'CHECK_IN'
        };
        console.log(this.crmurl+'&page='+index+'&size='+size)
        return this.http.get(this.crmurl+'&page='+index+'&size='+size);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }
    getAlldoucument():Observable<any>{
        let urldoc = environment.crmTest +'/doctypes';
        return this.http.get(urldoc);
    }

    getCountryName(alpha2){
        //https://crmapi.valeriahotels.com/api/country/
        let urldoc = environment.crmTest +'/country/'+alpha2;
        console.log(alpha2);
        
        return this.http.get(urldoc);
    }

    getPayments(body):Observable<any>{
        console.log("body",body);
        

       

      
        let urldoc = environment.crmTest +'/payments?group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        
        
        if(body.createdDateFrom!=''){
            urldoc = urldoc+'&createdfrom='+ body.createdDateFrom;
        }
        if(body.createdDateTo!=''){
            urldoc = urldoc +"&createdto="+body.createdDateTo;
        }
        
       
        
       
       
       
        return this.http.get(urldoc);
    }

   
    getReservationsN(checkinDate:any,checkoutDate:any,reservationStatusFilter:any){
        let url = this.crmurl;

        if (checkinDate !== undefined ) {
            //console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + '&from=' + checkinDate ;
        }
        if (checkoutDate !== undefined) {
            console.log("this.checkinDate in service checkin", checkinDate);
            url = url + '&to=' + checkoutDate;
        }

        url=url+'&resastatus='+reservationStatusFilter
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        console.log(url);
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }
    getAllCheckinsAV2(){
        let url = this.crmurl;
        if (this.convertedDateCre !== undefined  && this.convertedDateCreV2 == undefined) {
            let previousDate = new Date(this.convertedDateCre);
            previousDate.setDate(this.convertedDateCre.getDate());
            let formattedPreviousDate = previousDate.toISOString().substring(0, 10);

            let nextDate = new Date(this.convertedDateCre);
            nextDate.setDate(this.convertedDateCre.getDate() + 1);
            let formattedNextDate = nextDate.toISOString().substring(0, 10);
            url = url + '&createdfrom=' + formattedPreviousDate + '&createdto=' + formattedNextDate;
        }
         if (this.convertedDateCre !== undefined  && this.convertedDateCreV2 !== undefined) {
            let previousDate = new Date(this.convertedDateCre);
            previousDate.setDate(this.convertedDateCre.getDate());
            let formattedPreviousDate = previousDate.toISOString().substring(0, 10);

            let nextDate = new Date(this.convertedDateCreV2);
            nextDate.setDate(this.convertedDateCreV2.getDate() + 1);
            let formattedNextDate = nextDate.toISOString().substring(0, 10);
            url = url + '&createdfrom=' + formattedPreviousDate + '&createdto=' + formattedNextDate;
        }
        if (this.checkinDate !== undefined && this.cancelldFromDate == undefined ) {
            //console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + '&from=' + this.checkinDate ;
        }
        if (this.checkoutDate !== undefined && this.cancelldFromDate == undefined) {
            console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + '&to=' + this.checkoutDate;
        }
        if(this.numberAgenceFilter !== undefined){
          url = url + '&number=' + this.numberAgenceFilter;
        }
        if(this.segmentsFilter !== undefined){
          url = url + '&segmentid='+this.segmentsFilter;
        }
        if(this.cancelldFromDate !== undefined){
             url = url + '&canceledfrom=' + this.cancelldFromDate;
        }
        if(this.cancelledToDate !== undefined){
             url = url + '&canceledto=' + this.cancelledToDate;

        }
        if(this.userSleced !== 0){
           url = url + '&userid=' + this.userSleced;
        }
        /*       if (this.checkinDate === undefined && this.checkoutDate === undefined) {
              const currentDate = new Date();
              const year = currentDate.getFullYear();
              const month = String(currentDate.getMonth() + 1).padStart(2, '0');
              const day = String(currentDate.getDate()).padStart(2, '0');
              const formattedDate = `${year}-${month}-${day}`;
              url = url + 'from=' + formattedDate + '&to=' + formattedDate;
            }*/

        if(this.guestFilter!==undefined){
            url=url+'&guest='+this.guestFilter
        }
        if(this.customerFilter!==undefined){
            url=url+'&customer='+this.customerFilter
        }
        if(this.numberFilter!==undefined){
            url=url+'&bookingnumber='+this.numberFilter
        }
        if(this.reservationStatusFilter !== undefined && this.reservationStatusFilter !== null){
            url=url+'&resastatus='+this.reservationStatusFilter
        }
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        console.log(url);
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }
    getAllCheckinsA(){
        let url = this.crmurl;
        if (this.convertedDateCre !== undefined) {
            let previousDate = new Date(this.convertedDateCre);
            previousDate.setDate(this.convertedDateCre.getDate());
            let formattedPreviousDate = previousDate.toISOString().substring(0, 10);

            let nextDate = new Date(this.convertedDateCre);
            nextDate.setDate(this.convertedDateCre.getDate() + 1);
            let formattedNextDate = nextDate.toISOString().substring(0, 10);
            url = url + '&createdfrom=' + formattedPreviousDate + '&createdto=' + formattedNextDate;
        }
        if (this.checkinDate !== undefined && this.cancelldFromDate == undefined ) {
            //console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + '&from=' + this.checkinDate ;
        }
        if (this.checkoutDate !== undefined && this.cancelldFromDate == undefined) {
            console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + '&to=' + this.checkoutDate;
        }
        if(this.numberAgenceFilter !== undefined){
          url = url + '&number=' + this.numberAgenceFilter;
        }
        if(this.segmentsFilter !== undefined){
          url = url + '&segmentid='+this.segmentsFilter;
        }
        if(this.cancelldFromDate !== undefined){
             url = url + '&canceledfrom=' + this.cancelldFromDate;
        }
        if(this.cancelledToDate !== undefined){
             url = url + '&canceledto=' + this.cancelledToDate;

        }
        if(this.userSleced !== 0){
           url = url + '&userid=' + this.userSleced;
        }
        /*       if (this.checkinDate === undefined && this.checkoutDate === undefined) {
              const currentDate = new Date();
              const year = currentDate.getFullYear();
              const month = String(currentDate.getMonth() + 1).padStart(2, '0');
              const day = String(currentDate.getDate()).padStart(2, '0');
              const formattedDate = `${year}-${month}-${day}`;
              url = url + 'from=' + formattedDate + '&to=' + formattedDate;
            }*/

        if(this.guestFilter!==undefined){
            url=url+'&guest='+this.guestFilter
        }
        if(this.customerFilter!==undefined){
            url=url+'&customer='+this.customerFilter
        }
        if(this.numberFilter!==undefined){
            url=url+'&bookingnumber='+this.numberFilter
        }
        if(this.reservationStatusFilter !== undefined && this.reservationStatusFilter !== null){
            url=url+'&resastatus='+this.reservationStatusFilter
        }
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        console.log(url);
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }
    getInvoice(){
        let url = this.invoiceurl;
        url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        if(this.checkinDate !== undefined){
            url = url +'&createdfrom='+this.checkinDate;
        }
        if(this.checkoutDate !== undefined){
            url = url + '&createdto='+this.checkoutDate;
        }
        if(this.customerFilter !== undefined){
            url = url + '&customer='+this.customerFilter;
        } 
        if(this.numberFilter !== undefined){
            url = url + '&number='+this.numberFilter;
        }

        if(this.segement !== undefined){
           url = url +'&segment='+this.segement;
        }
        if(this.SentBavel !== undefined &&  this.SentBavel.trim() !='All'){
            if(this.SentBavel.trim() =='Yes'){
              url = url +'&sentToBO=true';
            }
            if(this.SentBavel.trim() =='No'){
              url = url +'&sentToBO=false';
            }
               
        }
        // url = url + '&status=7'
        return this.http.get(url);

    }

    getInvoiceStatusFAE(status: any) {
        let url = this.crmurl;
        url = url + '&group=' + JSON.parse(localStorage.getItem("userDetails")).group.groupId;

        if (this.checkinDate !== undefined) {
            url = url + '&from=' + this.checkinDate;
        }

        if (this.checkoutDate !== undefined) {
            const adjustedCheckout = new Date(this.checkoutDate);
            adjustedCheckout.setDate(adjustedCheckout.getDate());
            const adjustedDateStr = adjustedCheckout.toISOString().split('T')[0]; // format: YYYY-MM-DD
            url = url + '&to=' + adjustedDateStr;
        }

        url = url + '&resastatus=' + status;
        return this.http.get(url);
    }

     getInvoiceComptable(){
        let url = environment.crmTest + '/accounting-entries?';
        url = url + '&groupId='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        if(this.checkinDate !== undefined){
            url = url +'&operationDateFrom='+this.checkinDate+'T00:00:00';
        }
        if(this.checkoutDate !== undefined){
            url = url + '&operationDateTo='+this.checkoutDate+'T23:59:59';
        }
        if(this.customerFilter !== undefined){
            url = url + '&customer='+this.customerFilter;
        } 
        if(this.numberFilter !== undefined){
            url = url + '&number='+this.numberFilter;
        }

        if(this.segement !== undefined){
           url = url +'&segment='+this.segement;
        }
        return this.http.get(url);

    }

   getCAComptable(checkinDate:any) {
  let url = environment.crmTest + '/closingdates/entries?';
  const groupId = JSON.parse(localStorage.getItem("userDetails"))?.group?.groupId;
  url += '&group=' + groupId;

  if (checkinDate !== undefined) {
    const inputDate = new Date(checkinDate);
    const today = new Date();

    // ⚠️ Ignore l'heure pour comparaison de date
    const isToday =
      inputDate.getDate() === today.getDate() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getFullYear() === today.getFullYear();

    if (isToday) {
      // ⏪ Reculer d'un jour
      inputDate.setDate(inputDate.getDate() - 1);
    }

    const formattedDate = inputDate.toISOString().split('T')[0]; // ✅ Format yyyy-mm-dd
    url += '&closingdate=' + formattedDate;
  }

  return this.http.get(url);
}




    getDebtorInvoice(body){
        let url = this.invoiceurl;
        url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        if(body.createdDateFrom !== null){
            url = url +'&createdfrom='+body.createdDateFrom;
        }
        if(body.createdDateTo !== null){
            url = url + '&createdto='+body.createdDateTo;
        }
        if(body.customer !== null){
            url = url + '&customer='+body.customer;
        } 
        if(body.invoiceNumber !== null){
            url = url + '&number='+body.invoiceNumber;
        }
        return this.http.get(url);

    }
    DownloadInvoice(): Observable<any> {
        let url = this.invoiceurlDownlad;
        url = url + '&group=' + JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        if (this.checkinDate !== undefined) {
          url = url + '&createdfrom=' + this.checkinDate;
        }
        if (this.checkoutDate !== undefined) {
            // Create a new date object to avoid modifying the original
            const nextDay = new Date(this.checkoutDate);
            nextDay.setDate(nextDay.getDate() + 1); // Add 1 day
            
            // Format as YYYY-MM-DD
            const formattedDate = nextDay.toISOString().split('T')[0];
            
            url = url + '&createdto=' + formattedDate;
        }
        if (this.customerFilter !== undefined) {
          url = url + '&customer=' + this.customerFilter;
        } 

       if(this.SentBavel !== undefined &&  this.SentBavel.trim() !='All'){
            if(this.SentBavel.trim() =='Yes'){
              url = url +'&sentToBO=true';
            }
            if(this.SentBavel.trim() =='No'){
              url = url +'&sentToBO=false';
            }
               
        }

        // url = url + '&status=7'
    
        // Open the URL in a new window
        window.open(url, '_blank');
    
        // Return a dummy observable since we're not subscribing to the HTTP request
        return new Observable(); // You can also return null or undefined here
     }

/*
    getReservations(body): Observable<any> {
        console.log("reservationBody : ",body);
        let url = this.reservationService+ '?group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    
       if(body.createdDateFrom){url = url + '&createdfrom='+body.createdDateFrom }
       if(body.createdDateTo){url = url + '&createdto='+body.createdDateTo }
       else{
        if (body.createdDateFrom) {
            // Convert createdDateFrom to a Date object
            var fromDate = new Date(body.createdDateFrom);
            // Add one day to fromDate
            fromDate.setDate(fromDate.getDate() + 1);
            // Convert it back to string in the desired format
            var toDate = fromDate.toISOString().split('T')[0]; 
            // Assuming createdDateFrom is in ISO format
            console.log("fromDate",body.createdDateFrom);
           
            console.log("todate",toDate);
            
            url = url + '&createdto=' +  toDate;
        }    
       }
       if(body.checkinDate){url = url + '&from='+body.checkinDate };
       if(body.checkoutDate){url = url + '&to='+body.checkoutDate };

    //    if(body.createdDate){url = url + '&to='+body.createdDate };
       if(body.partner){url = url + '&customer='+body.partner };
       if(body.segmentId && body.segmentId != undefined ){url = url + '&segmentid='+body.segmentId };

       console.log("body.status : ", body.status);
       
       if(body.roomType){url = url + '&roomtype='+body.roomType }

    //    if(body.status!=null ){url = url + '&resastatus=' + body.status };
        if (body.status !== null && !body.status.includes('All')) {
            // Créer un tableau de requêtes HTTP pour chaque statut
            const requests = body.status.map(s => {
                const completeUrl = `${url}&resastatus=${s}`;
                console.log("Statut:", s);
                console.log("URL appelée :", completeUrl);

                // Effectuer la requête HTTP GET pour chaque URL de statut
                return this.http.get(completeUrl).pipe(
                    map((results: any) => {
                        // Appliquer le filtre personnalisé si les dates de check-in et check-out sont fournies
                        if (body.checkinDate && body.checkoutDate) {
                            console.log("Application du filtre personnalisé dans le service");
                            return results.filter(resa =>
                                this.convertirDateFRtoISO(resa.checkout) !== this.convertirDateFRtoISO(body.checkinDate) &&
                                resa.roomName != null && resa.roomName.trim() !== ""
                            );
                        }
                        return results;
                    })
                );
            });

            // Utilisation de forkJoin pour exécuter toutes les requêtes simultanément
            return forkJoin(requests).pipe(
                map((allResults: any[]) => {
                    // Fusionner les résultats de toutes les requêtes dans un seul tableau
                    const combinedResults = [].concat(...allResults);
                    console.log("Résultats combinés :", combinedResults);
                    return combinedResults;
                })
            );
        }
            else{
                console.log("status",body.status);

                console.log("called url : ",url);
                return this.http.get(url).pipe(
                    map((results: any) => {
                        // Apply the custom filter here
                        if (body.checkinDate && body.checkoutDate) {
                            console.log("Applying custom filter in the service");
                            return results.filter(resa =>
                                this.convertirDateFRtoISO(resa.checkout) !== this.convertirDateFRtoISO(body.checkinDate) &&
                                resa.roomName != null && resa.roomName.trim() !== ""
                            );
                        }
                        return results;
                    })
                );
            }


            // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }
*/
    getReservations(body): Observable<any> {
        console.log("reservationBody : ",body);
        const _ud3 = JSON.parse(localStorage.getItem('userDetails') || 'null');
        if (!_ud3 || !_ud3.group) { return EMPTY; }
        let url = this.reservationService+ '?group='+_ud3.group.groupId;

        if(body.createdDateFrom){url = url + '&createdfrom='+body.createdDateFrom }
        if(body.createdDateTo){url = url + '&createdto='+body.createdDateTo }
        else{
            if (body.createdDateFrom) {
                // Convert createdDateFrom to a Date object
                var fromDate = new Date(body.createdDateFrom);
                // Add one day to fromDate
                fromDate.setDate(fromDate.getDate() + 1);
                // Convert it back to string in the desired format
                var toDate = fromDate.toISOString().split('T')[0];
                // Assuming createdDateFrom is in ISO format
                console.log("fromDate",body.createdDateFrom);

                console.log("todate",toDate);

                url = url + '&createdto=' +  toDate;
            }
        }
        if(body.checkinDate){url = url + '&from='+body.checkinDate };
        if(body.checkoutDate){url = url + '&to='+body.checkoutDate };

        //    if(body.createdDate){url = url + '&to='+body.createdDate };
        if(body.partner){url = url + '&customer='+body.partner };
        if(body.segmentId && body.segmentId != undefined ){url = url + '&segmentid='+body.segmentId };

        console.log("body.status : ", body.status);

        if(body.status!=null ){url = url + '&resastatus=' + body.status };
        if(body.roomType){url = url + '&roomtype='+body.roomType }
        ;




        console.log("status",body.status);

        console.log("called url : ",url);
        return this.http.get(url).pipe(
            map((results: any) => {
                // Apply the custom filter here
                if (body.checkinDate && body.checkoutDate) {
                    console.log("Applying custom filter in the service");
                    return results.filter(resa =>
                        this.convertirDateFRtoISO(resa.checkout) != this.convertirDateFRtoISO(body.checkinDate) &&
                        resa.roomName != null && resa.roomName.trim() !== ""
                    );
                }
                return results;
            })
        );        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }

    getReservationsMultipleStatus(body): Observable<any> {
        console.log("reservationBody : ", body);
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        let url = `${this.reservationService}?group=${userDetails.group.groupId}`;

        // Append query parameters based on the presence of properties in the body
        if (body.createdDateFrom) {
            url += `&createdfrom=${body.createdDateFrom}`;
        }
        if (body.createdDateTo) {
            url += `&createdto=${body.createdDateTo}`;
        } else {
            if (body.createdDateFrom) {
                // Convert createdDateFrom to a Date object and add one day
                const fromDate = new Date(body.createdDateFrom);
                fromDate.setDate(fromDate.getDate() + 1);
                const toDate = fromDate.toISOString().split('T')[0];
                console.log("fromDate", body.createdDateFrom);
                console.log("toDate", toDate);
                url += `&createdto=${toDate}`;
            }
        }
        if (body.checkinDate) {
            url += `&from=${body.checkinDate}`;
        }
        if (body.checkoutDate) {
            url += `&to=${body.checkoutDate}`;
        }
        if (body.partner) {
            url += `&customer=${body.partner}`;
        }
        if (body.segmentId !== undefined && body.segmentId !== null) {
            url += `&segmentid=${body.segmentId}`;
        }

        console.log("body.status : ", body.status);

        if (body.roomType) {
            url += `&roomtype=${body.roomType}`;
        }

        // Normalize body.status to an array if it's a string
        let statuses: string[] = [];
        if (Array.isArray(body.status)) {
            statuses = body.status;
        } else if (typeof body.status === 'string') {
            statuses = [body.status];
        }

        // Check if statuses array is not empty and does not include 'All'
        if (statuses.length > 0 && !statuses.includes('All')) {
            // Create an array of HTTP GET observables for each status
            const requests = statuses.map(status => {
                const completeUrl = `${url}&resastatus=${encodeURIComponent(status)}`;
                console.log("Statut:", status);
                console.log("URL appelée :", completeUrl);

                // Perform the HTTP GET request for each status URL
                return this.http.get(completeUrl).pipe(
                    map((results: any[]) => {
                        // Apply the custom filter if checkinDate and checkoutDate are provided
                        if (body.checkinDate && body.checkoutDate) {
                            console.log("Application du filtre personnalisé dans le service");
                            return results.filter(resa =>
                                this.convertirDateFRtoISO(resa.checkout) !== this.convertirDateFRtoISO(body.checkinDate) &&
                                resa.roomName != null && resa.roomName.trim() !== ""
                            );
                        }
                        return results;
                    })
                );
            });

            // Use forkJoin to execute all HTTP requests simultaneously
            return forkJoin(requests).pipe(
                map((allResults: any[][]) => {
                    // Flatten the array of arrays into a single array
                    const combinedResults = [].concat(...allResults);
                    console.log("Résultats combinés :", combinedResults);
                    return combinedResults;
                })
            );
        } else {
            // Handle the case where status is a single value or includes 'All'
            console.log("status", body.status);
            console.log("called url : ", url);

            return this.http.get(url).pipe(
                map((results: any[]) => {
                    // Apply the custom filter if checkinDate and checkoutDate are provided
                    if (body.checkinDate && body.checkoutDate) {
                        console.log("Applying custom filter in the service");
                        return results.filter(resa =>
                            this.convertirDateFRtoISO(resa.checkout) !== this.convertirDateFRtoISO(body.checkinDate) &&
                            resa.roomName != null && resa.roomName.trim() !== ""
                        );
                    }
                    return results;
                })
            );
        }
    }

    getReservationsV2(body){
        console.log("reservationBody : ",body);
        let url = this.reservationServiceV2+ '?group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
       if(body.createdDateFrom){url = url + '&createdfrom='+body.createdDateFrom }
       if(body.createdDateTo){url = url + '&createdto='+body.createdDateTo }
       else{
        if (body.createdDateFrom) {
            // Convert createdDateFrom to a Date object
            var fromDate = new Date(body.createdDateFrom);
            // Add one day to fromDate
            fromDate.setDate(fromDate.getDate() + 1);
            // Convert it back to string in the desired format
            var toDate = fromDate.toISOString().split('T')[0]; 
            // Assuming createdDateFrom is in ISO format
            console.log("fromDate",body.createdDateFrom);
           
            console.log("todate",toDate);
            
            url = url + '&createdto=' +  toDate;
        }    
       }
       if(body.checkinFrom){
        url = url + '&checkinfrom='+body.checkinFrom
    if(body.checkinTo == null){
        url = url + '&checkinto='+body.checkinFrom
    }
    };
       if(body.checkinTo){
    if(body.checkinFrom == null ){
        url = url + '&checkinfrom='+body.checkinTo

    }
    url = url + '&checkinto='+body.checkinTo;};
       if(body.checkoutFrom){url = url + '&chekoutfrom='+body.checkoutFrom
       if(body.checkoutTo == null){
        url = url + '&checkoutto='+body.checkoutFrom
       }
    };
       if(body.checkoutTo){
        if(body.checkoutFrom == null){
            url = url + '&chekoutfrom='+body.checkoutTo
 }
        url = url + '&checkoutto='+body.checkoutTo };
       if(body.partner){url = url + '&customer='+body.partner };
       if(body.segmentId){url = url + '&segmentid='+body.segmentId };
       if(body.status!=null ){url = url + '&resastatus=' + body.status };
       if(body.roomType){url = url + '&roomtype='+body.roomType };
        return this.http.get<any>(url);
    }
   

    getAllGroup(): Observable<any>{
       return this.http.get(this.crmApi + "/allgroups") ;
    }
    getEvents(EventBody : any  ){
        let url = this.crmApi + "/audit/allevent?type=" + EventBody.type  ;
        
        return this.http.get( url );

        

    }
    exportReservationsV2(body){
        console.log("reservationBody : ",body);
        
        let url = this.reservationServiceV2+ '/export?group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

    
       if(body.createdDateFrom){url = url + '&createdfrom='+body.createdDateFrom }else{
        
     
       }
       if(body.createdDateTo){url = url + '&createdto='+body.createdDateTo }
       else{
        if (body.createdDateFrom) {
            // Convert createdDateFrom to a Date object
            var fromDate = new Date(body.createdDateFrom);
            // Add one day to fromDate
            fromDate.setDate(fromDate.getDate() + 1);
            // Convert it back to string in the desired format
            var toDate = fromDate.toISOString().split('T')[0]; 
            // Assuming createdDateFrom is in ISO format
            console.log("fromDate",body.createdDateFrom);
           
            console.log("todate",toDate);
            
            url = url + '&createdto=' +  toDate;
        }    
       }
       if(body.checkinFrom){
        url = url + '&checkinfrom='+body.checkinFrom
    if(body.checkinTo == null){
        url = url + '&checkinto='+body.checkinFrom
    }
    };
       if(body.checkinTo){
    if(body.checkinFrom == null ){
        url = url + '&checkinfrom='+body.checkinTo

    }
    url = url + '&checkinto='+body.checkinTo;
    };
       if(body.checkoutFrom){url = url + '&chekoutfrom='+body.checkoutFrom
       if(body.checkoutTo == null){
        url = url + '&checkoutto='+body.checkoutFrom
       }
    };
      
       if(body.checkoutTo){
        if(body.checkoutFrom == null){
            url = url + '&chekoutfrom='+body.checkoutTo
        }
        url = url + '&checkoutto='+body.checkoutTo };

        if (body.invoiced !== null && body.invoiced !== undefined && body.invoiced !== "null") {
            let invoicedBoolean = String(body.invoiced).toLowerCase() === "true"; // Convertit en booléen correct
        
            if (invoicedBoolean) {
                url = url + '&invoiced=true';
            } else {
                url = url + '&invoiced=false';
            }
        
            console.log("here my url become like this:", url);
        }
        
      

    //    if(body.createdDate){url = url + '&to='+body.createdDate };
       if(body.partner){url = url + '&customer='+body.partner };
       if(body.segmentId){url = url + '&segmentid='+body.segmentId };
       
       console.log("body.status : ", body.status);
       
       if(body.status!=null ){url = url + '&resastatus=' + body.status };
       if(body.roomType){url = url + '&roomtype='+body.roomType };


       
       
        console.log("status",body.status);
        
        console.log("called url : ",url);
        this.ExportUrlV1 = url
        // return this.http.get<any>(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }
    exportReservationsToCsv(body){
        console.log("body AA",body);
        let url = this.reservationService+ '/export?group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
       if(body.createdDateFrom){url = url + '&createdfrom='+body.createdDateFrom }else{
       }
       if(body.createdDateTo){url = url + '&createdto='+body.createdDateTo }
       else{
        if (body.createdDateFrom) {
            var fromDate = new Date(body.createdDateFrom);
            fromDate.setDate(fromDate.getDate() + 1);
            var toDate = fromDate.toISOString().split('T')[0];
            console.log("fromDate",body.createdDateFrom);
           
            console.log("todate",toDate);
            
            url = url + '&createdto=' +  toDate;
        }    
       }
       if (body.invoiced !== null && body.invoiced !== undefined) {
        if(body.invoiced == true){
         url = url + '&invoiced=true';
        }else{
         url = url + '&invoiced=false';
        }
        console.log("here my url become like this:",url);
        // url += `&invoiced=${body.invoiced ? 'true' : 'false'}`;
       }
       if(body.checkinDate){url = url + '&from='+body.checkinDate };
       if(body.checkoutDate){url = url + '&to='+body.checkoutDate };
       if(body.partner){url = url + '&customer='+body.partner };
       if(body.segmentId && body.segmentId != undefined ){url = url + '&segmentid='+body.segmentId };
       console.log("body.status",body.status);
       if(body.status!=null &&  body.status.length!=0 &&  body.status!= undefined){
        url = url + '&resastatus=' + body.status 
       }
       if(body.roomType){url = url + '&roomtype='+body.roomType }
        console.log("status",body.status);
        
        console.log("called url : ",url);
        this.ExportUrlV1 = url
        return this.http.get(url);
    }
    exportMC(closingDate){
        //https://pmsvaleriaapi.fractalstay.com/api/reservations/dailyreport/export?user=1&status=4&closingdate=2024-05-15
        console.log(JSON.parse(localStorage.getItem("userDetails")));
        
        let url = this.reservationService+'/dailyreport/export?'+ 'user='+JSON.parse(localStorage.getItem("userDetails")).userId +'&status=2'+'&closingdate='+closingDate ;

    
       
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }

    getAllCheckinsDepartAA(){
        let url = this.crmurl;
        if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
            console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + 'from=' + this.checkinDate + '&to=' + this.checkoutDate;
        } else if (this.checkinDate === undefined && this.checkoutDate === undefined) {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            url = url + '&to=' + formattedDate;
        } else if (this.checkinDate !== undefined && this.checkoutDate === undefined) {
            url = url + 'to=' + this.checkinDate
        }



        // if(this.guestFilter!==undefined){
        //   url=url+'&guest='+this.guestFilter
        // }
        // if(this.customerFilter!==undefined){
        //   url=url+'&customer='+this.customerFilter
        // }
        // if(this.numberFilter!==undefined){
        //   url=url+'&boNumber='+this.numberFilter
        // }

        url=url+'&resastatus=3'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;


        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }

    getAllCheckinsDepartAAV(){
        let url = this.crmurl;
        if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
            console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + '&to=' + this.checkoutDate;
        } else if (this.checkinDate === undefined && this.checkoutDate === undefined) {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            url = url + '&to=' + formattedDate;
        } else if (this.checkinDate !== undefined && this.checkoutDate === undefined) {
            url = url + 'to=' + this.checkinDate
        }



        // if(this.guestFilter!==undefined){
        //   url=url+'&guest='+this.guestFilter
        // }
        // if(this.customerFilter!==undefined){
        //   url=url+'&customer='+this.customerFilter
        // }
        // if(this.numberFilter!==undefined){
        //   url=url+'&boNumber='+this.numberFilter
        // }

        url=url+'&resastatus=2'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;


        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }
   
    Addtags(resa,tagsid){
        let url = this.createrese;
        url = url + '/' + resa + '/tag/add/' + this.azertyToQwertyAndNumbers(tagsid);
        return this.http.get(url);
    }
    
    initags(tagsid){
        let url = this.crmApi;
        url = url + '/rfid-wallets/init?rfidKey='+ this.azertyToQwertyAndNumbers(tagsid);
        return this.http.post(url,{});
    }

    setLimitags(tagsid,itemId,amountlimite){
        let url = this.crmApi;
        url = url + '/rfid-wallets/set-limit?rfidKey='+ this.azertyToQwertyAndNumbers(tagsid)+'&itemId='+itemId+'&limitAmount='+amountlimite;
        return this.http.post(url,{});
    }

    Remaintags(tagsid){
        let url = this.crmApi;
        url = url + '/rfid-wallets/remaining?rfidKey='+ this.azertyToQwertyAndNumbers(tagsid);
        return this.http.get(url);
    }

    getReser(resa){
        let url = this.createrese;
        url = url + '/' + resa ;
        return this.http.get(url);
    }
    DeleteTags(resa){
        let url = this.createrese;
        url = url + '/' + resa +'/tags';
        return this.http.delete(url);
    }
    getForConsumption(from:any,to:any){
        let url = this.crmurl;
        url = url + 'from=' + from + '&to=' + to ;
        url=url+'&resastatus=2';
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        return this.http.get(url)
    }
     getForConsumptionA(from:any,to:any){
        let url = this.crmurl;
        url = url + 'from=' + from + '&to=' + to ;
        url=url+'&resastatus=3';
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        return this.http.get(url)
    }


    getStartAndEndOfWeek(date = new Date()) {
        const dayOfWeek = date.getDay();
        const startOfWeek = new Date(date);
        const endOfWeek = new Date(date);
    
        startOfWeek.setDate(date.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1)); // Adjust to Monday
        endOfWeek.setDate(date.getDate() + (dayOfWeek === 0 ? 0 : 7 - dayOfWeek)); // Adjust to Sunday
    
        return {
            start: `${startOfWeek.getFullYear()}-${(startOfWeek.getMonth() + 1).toString().padStart(2, '0')}-${startOfWeek.getDate().toString().padStart(2, '0')}`,
            end: `${endOfWeek.getFullYear()}-${(endOfWeek.getMonth() + 1).toString().padStart(2, '0')}-${endOfWeek.getDate().toString().padStart(2, '0')}`
        };
    }
    getAllCheckinsArrival1() {
        let url = this.crmurl;
    
        const { start, end } = this.getStartAndEndOfWeek(); // Get current week range
    
        // Build URL with start and end dates
        url += `from=${start}&to=${end}`;
    
        // Add additional filters if defined
        if (this.guestFilter !== undefined) {
            url += `&guest=${this.guestFilter}`;
        }
        if (this.customerFilter !== undefined) {
            url += `&customer=${this.customerFilter}`;
        }
        if (this.numberFilter !== undefined) {
            url += `&boNumber=${this.numberFilter}`;
        }
    
        url += '&resastatus=0'; // Assuming you want to filter by some status
        url += `&group=${JSON.parse(localStorage.getItem("userDetails")).group.groupId}`;
    
        console.log("Final URL for fetching check-ins:", url);
    
        return this.http.get(url);
    }
    

    getAllCheckinsArrival(){
        let url = this.crmurl;
        if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
            console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + 'from=' + this.checkinDate + '&to=' + this.checkoutDate;
        } else if (this.checkinDate === undefined && this.checkoutDate === undefined) {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            url = url + 'from=' + formattedDate;
        } else if (this.checkinDate !== undefined && this.checkoutDate === undefined) {
            url = url + 'from=' + this.checkinDate ;
            console.log("check by mouhcine for checkin ",url);
        }
        else if (this.checkoutDate !== undefined && this.checkinDate === undefined) {
            url =  url + 'to=' + this.checkoutDate ;
        }


        if(this.guestFilter!==undefined){
            url=url+'&guest='+this.guestFilter
        }
        if(this.customerFilter!==undefined){
            url=url+'&customer='+this.customerFilter
        }
        if(this.numberFilter!==undefined){
            url=url+'&boNumber='+this.numberFilter
        }
        url=url+'&resastatus=0'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        console.log(url)
        return this.http.get(url);
    }
    
    getAllCheckinsArrivalNextMonths() {
        const urlBase = environment.api + '/reservations?';
        const today = new Date();
        const checkinFrom = new Date(today);
        checkinFrom.setDate(today.getDate() + 1); // Demain
        const checkinTo = new Date(checkinFrom);
        checkinTo.setDate(checkinFrom.getDate() + 30); // 30 jours après demain
        const formatDate = (d: Date) => d.toISOString().split('T')[0]; // yyyy-MM-dd
        let url = urlBase;
        url += '&resastatus=0';
        url += '&from=' + formatDate(checkinFrom);
        url += '&to=' + formatDate(checkinTo);
        url += '&group=' + JSON.parse(localStorage.getItem("userDetails"))?.group?.groupId;

        console.log('✅ Final URL:', url);

        return this.http.get(url);
    }


    getAllCheckinsDepart(){
        let url = this.crmurl;
        if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
            console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + 'from=' + this.checkinDate + '&to=' + this.checkoutDate;
        } else if (this.checkinDate === undefined && this.checkoutDate === undefined) {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            url = url + '&to=' + formattedDate;
        } else if (this.checkinDate !== undefined && this.checkoutDate === undefined) {
            url = url + 'to=' + this.checkinDate
        }


        // if(this.guestFilter!==undefined){
        //   url=url+'&guest='+this.guestFilter
        // }
        // if(this.customerFilter!==undefined){
        //   url=url+'&customer='+this.customerFilter
        // }
        // if(this.numberFilter!==undefined){
        //   url=url+'&boNumber='+this.numberFilter
        // }

        url=url+'&resastatus=2'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;


        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }
    getAllCheckinsInhouse(){
        let url = this.crmurl;
        if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
            console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + 'from=' + this.checkinDate + '&to=' + this.checkoutDate;
        } else if (this.checkinDate === undefined && this.checkoutDate === undefined) {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            url = url + 'from=' + formattedDate ;
        } else if (this.checkinDate !== undefined && this.checkoutDate === undefined) {
            url = url + 'from=' + this.checkinDate ;
            console.log("aa",url);

        } else if (this.checkoutDate !== undefined && this.checkinDate === undefined) {
            url =  url + 'to=' + this.checkoutDate ;
            console.log("bba",url);
        }


        if(this.guestFilter!==undefined){
          url=url+'&guest='+this.guestFilter
        }
        if(this.customerFilter!==undefined){
          url=url+'&customer='+this.customerFilter
        }
        if(this.numberFilter!==undefined){
          url=url+'&boNumber='+this.numberFilter
        }
        if(this.reservationStatusFilter!==undefined){
          url=url+'&resastatus='+this.reservationStatusFilter
        }
        url=url+'&resastatus=2'
        const _ud1 = JSON.parse(localStorage.getItem('userDetails') || 'null');
        if (!_ud1 || !_ud1.group) { return EMPTY; }
        url = url+'&group='+_ud1.group.groupId;

        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }

    getAllCheckinsInhouseBD(){
        let url = this.crmurl;
        url=url+'&resastatus=2'
        const _ud2 = JSON.parse(localStorage.getItem('userDetails') || 'null');
        if (!_ud2 || !_ud2.group) { return EMPTY; }
        url = url+'&group='+_ud2.group.groupId;

        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }


   
  
    getAllArrival(selectedDate: Date) {
    let url = this.crmurl + '&resastatus=0';

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const day = String(selectedDate.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    url += '&from=' + formattedDate;
    url += '&group=' + JSON.parse(localStorage.getItem("userDetails")).group.groupId;

    return this.http.get(url);
    }


    getAllCheckinsInhouseCalculate(){
        let url = this.crmurl;
        url=url+'&resastatus=2'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }

    getAllCheckinsInhouseCalculateCMD(Date){
        let url = this.crmurl;
        url = url + '&from='+Date+'&to='+Date;
        url=url+'&resastatus=2'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }
    getAllCheckinDUEOUtCalculateCMD(Date){
        let url = this.crmurl;
        url = url + '&to='+Date;
        url=url+'&resastatus=2'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }
    getAllCheckinArrivedCalculateCMD(Date){
        let url = this.crmurl;
        url = url + '&from='+Date;
        url=url+'&resastatus=0'
        url = url+'&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;

        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

    }

    getAllCheckinsPMS(index: number, size: number){
        return this.http.get(this.apiCheckIn+'?pageNo='+index+'&pageSize='+size);3
    }

    getAllTodayCheckoutsPMS(index: number, size: number){
        return this.http.get(this.apiCheckIn+'/today_checkouts?pageNo='+index+'&pageSize='+size);
    }

    getAllTodayCheckouts(index: number, size: number){
        return this.http.get(this.apiCheckIn+'/today_checkouts?pageNo='+index+'&pageSize='+size);
    }
    getStatsForCheckin(index:number){
        //got to see with Kasmi for CRM
        const body = {
            //'url': this.url+'page='+index+'&type=Customer&producttype=1',
            'status':'CHECK_IN'
        };
        console.log(body)
        return this.http.post(this.api+'/checkingStats',body)
    }

    getAllCheckOut(index:number, size:number){
        const body = {
            //'url': this.url+'page='+index+'&type=Customer&producttype=1',
            'status':'CHECK_OUT'
        };
        console.log(body)
        // return this.http.post(this.api+'/toCheckOut',body);
        return this.http.get(this.apiCheckIn+'?page='+index+'&size='+size);
    }
    getAllCheckIn(index:number){
        const body = {
            //'url': this.url+'page='+index+'&type=Customer&producttype=1',
            'status':'CHECK_OUT'
        };
        console.log(body)
        return this.http.post(this.api+'/toCheckIn',body);
    }

    getAllNumberCheckIn(){
        return this.http.get(this.apiCheckIn + '/numbers');
    }

    getCheckInByOrder(order:Order){
        return this.http.post(this.api+'/getByOrder',order);
    }

    getGeneratedRoomsRandomly(count:number,roomType:RoomType){
        console.log(roomType)
        return this.http.post(this.api+'/random_checkin/'+count,roomType);
    }
    getAutoCheckInRoom(id: number){
        return this.http.get(this.apiCheckIn + '/room/' + id + '/CLEAN/EMPTY');
    }

    createCheckIn(checkin:CheckIn){
        return this.http.post(this.apiCheckIn+'/new',checkin);
    }
    createNewCheckIn(customerId:number,itemId:number,orderNumber:string,roomId:number){
        return this.http.post(this.api+'/new?customer='+customerId+'&item='+itemId+'&order='+orderNumber+'&room='+roomId,{"checkin":"to_check"});
    }

    deleteCheckin(checkin:CheckIn){
        return this.http.delete(this.api+'/'+checkin.checkInId);
    }

    getCheckInByItem(item:Item){
        return this.http.post(this.apiCheckIn+'/item',item);
    }

    getWeekCheckInStatistics(){
        return this.http.get(this.apiCheckIn+'/weekCheckIns');
    }

    getItembyId(id:any){
        console.log('get item by id',this.itemUrl+'/'+id);
        return this.http.get(this.itemUrl+'/'+id);
    }
    getItembyIdA(id: any): Observable<any> {
        console.log('get item by id', `${this.itemUrl}/${id}`);
        return this.http.get<any>(`${this.itemUrl}/${id}`);
    }

    getOrderbyItemId(id:any):Observable<Order>{
    const interval : number = 1000
        console.log('get item by id',this.itemUrl+'/'+id);
       return  this.http.get<Order>(this.itemOrderUrl+'/'+id)
    /* return timer(0, interval).pipe(
       switchMap(() => this.http.get<Order>(this.itemOrderUrl+'/'+id))
);*/
}


    getOrderbyItemIdPeriodically(id:any):Observable<Order>{
        const interval : number = 1000
        console.log('get item by id',this.itemUrl+'/'+id);
        /* return  this.http.get<Order>(this.itemOrderUrl+'/'+id)*/
        return timer(0, interval).pipe(
           switchMap(() => this.http.get<Order>(this.itemOrderUrl+'/'+id))
    );
    }
getOrderbyOrderID(id:any):Observable<Order>{
return this.http.get<Order>(this.itemOrderUrlOrder+'/'+id);
}
putReservation(reser: any,id:any){
return this.http.post(this.createrese, reser);
}
PostBavel(invoice:any):Observable<any>{
    let url = 'http://bob.fractalite.com/hermes/to/crm/bavel?target_url=test';
    return this.http.post(url, invoice);
}
// getReservations(id:any){
//   return this.http.get(this.createrese+'/'+id);
// }

putItem(item:Item){
console.log("here item ins e]s",item);
console.log("put item in this url",this.itemUrl);
return this.http.put(this.itemUrl,item);
}

    getAllCheckinsFromTo(checkinDate : any,checkoutDate : any ) {
        let url = this.crmurl;
            console.log('startService',checkinDate)
            //console.log("this.checkinDate in service checkin", this.checkinDate);
            url = url + '&from=' + checkinDate + '&to=' + checkoutDate;

        url = url+'&group=' + JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        console.log(url);
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    }
    getAllCheckinsFromToActive(checkinDate?: any, checkoutDate?: any, createdFrom?: string, createdTo?: string) {
        let url = this.crmurl;
        console.log('startService', checkinDate);

        if (checkinDate) {
            url = `${url}&from=${checkinDate}`;
        }
        if (checkoutDate) {
            url = `${url}&to=${checkoutDate}`;
        }
        const groupId = JSON.parse(localStorage.getItem("userDetails")).group.groupId;
        url = `${url}&group=${groupId}`;

        if (createdFrom) {
            url = `${url}&createdfrom=${createdFrom}`;
        }
        if (createdTo) {
            url = `${url}&createdto=${createdTo}`;
        }

        const url1 = `${url}&resastatus=0`;
        const url2 = `${url}&resastatus=2`;
        const url3 = `${url}&resastatus=3`;

        console.log('URL 1:', url1);
        console.log('URL 2:', url2);
        console.log('URL 3:', url3);


        const request1 = this.http.get(url1);
        const request2 = this.http.get(url2);
        const request3 = this.http.get(url3);


        return forkJoin([request1, request2,request3]);
    }
getResaByTag(tagsid:any){
    let pms_api = this.createrese + '/bytag';

    return this.http.get<any>(`${pms_api}/${ this.azertyToQwertyAndNumbers(tagsid)}`);

}

azertyToQwertyAndNumbers(input: string): string {
    // Mapping of specific AZERTY characters to QWERTY numbers
    const azertyToQwertyNumberMap: { [key: string]: string } = {
        '&': '1', 'é': '2', '"': '3', "'": '4', '(': '5',
        '-': '6', 'è': '7', '_': '8', 'ç': '9', 'à': '0'
    };

    // Regular expression to check for digits
    const isDigit = /^\d$/;

    // Convert the input string
    return input.split('').map(char => {
        if (isDigit.test(char)) {
            return char; // Return the character unchanged if it's a digit
        }
        return azertyToQwertyNumberMap[char] || ''; // Convert or ignore non-mapped characters
    }).join('');
}

    Exchange(from,to,amount){
    let url = environment.crmTest + '/exchange/v2/execute/3?fromCurr='+from+'&toCurr='+to+'&value='+amount;
    return this.http.get(url);
    }

    ExchangeA(from,to,amount){
    let url = environment.crmTest + '/exchange/v2/execute/1?fromCurr='+from+'&toCurr='+to+'&value='+amount;
    return this.http.get(url);
    }

    isDateFR(dateStr: string): boolean {
        // Vérifie si la date est au format "dd-mm-yyyy"
        const regexFR = /^\d{2}-\d{2}-\d{4}$/;
        return regexFR.test(dateStr);
    }

    convertirDateFRtoISO(dateFR: string): string {
        if (this.isDateFR(dateFR)) {
            const [jour, mois, annee] = dateFR.split("-");
            return `${annee}-${mois}-${jour}`;
        }
        return dateFR; // Si la date n'est pas au format FR, retourne la date d'origine
    }


    updateCustomer(customer: any): Observable<any> {
        return this.http.put(`https://crmapi.valeriahotels.com/api/customers/${customer.id}`, customer);
      }
      

      getAllSegments(): Observable<any>{
        return this.http.get(this.crmApi + "/segments") ;
     }

   
      
     // ✅ Recherche de segments par nom
searchSegments(name: string): Observable<any> {
    return this.http.get<any[]>(`${this.crmApi}/segments?name=${encodeURIComponent(name)}`);
  }
  
      
      // ✅ Création d’un nouveau segment
      createSegment(segment: { name: string; priority: number; tag: string }): Observable<any> {
        return this.http.post(this.crmApi + '/segment', segment);
      }
      updateSegment(segment: { segmentId: number; name: string; priority: number; tag: string }): Observable<any> {
        return this.http.put(`${this.crmApi}/segment/${segment.segmentId}`, segment);
      }
      deleteSegment(segmentId: number): Observable<any> {
        return this.http.delete(`${this.crmApi}/segment/${segmentId}`);
      }
      

      // service.ts
    getAllDocTypes(): Observable<DocType[]> {
        return this.http.get<DocType[]>(`${environment.crmTest}/alldoctypes`);
    }

        getCustomersWithoutCriteria(
        page: number,
        type: string, // e.g. 'all'
        group: number,
        size: number = 5000
        ): Observable<any> {
        let baseUrl = environment.crmTest; 
        baseUrl += '/customers';

        const params: string[] = [
            `page=${page}`,
            `group=${group}`,
            `type=${type}`,
            `size=${size}`
        ];

        baseUrl += '?' + params.join('&');

        console.log(`>>> [CheckInService] Fetching Customers: ${baseUrl}`);
        return this.http.get(baseUrl);
    }


    getCustomersBySegment(segmentId: number, groupId: number, page: number = 0, size: number = 20): Observable<any> {
    const url = `https://crmapi.valeriahotels.com/api/persons/segment/${segmentId}?page=${page}&group=${groupId}&size=${size}`;
    return this.http.get(url);
    }


    getAllSubDocumentTypes(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.crmTest}/subdoctypes`);
    }

    getAllCustomersBySegment(segmentId: number, groupId: number): Observable<any[]> {
        const url = `https://crmapi.valeriahotels.com/api/all/persons/by/segment/${segmentId}?group=${groupId}`;
        return this.http.get<any[]>(url);
    }

    getAllMicroCustomersBySegment(segmentId: number, groupId: number): Observable<any[]> {
        const url = `https://crmapi.valeriahotels.com/api/all/micropersons/by/segment/${segmentId}?group=${groupId}`;
        return this.http.get<any[]>(url);
    }

    getAllTotalsRooms(groupId: number): Observable<any> {
        const url = `${environment.api}/rooms/findAll/virtual?group=${groupId}`;
        return this.http.get(url);
    }



    // getStatementEntries(
    //     customerId: number, 
    //     from: string, 
    //     to: string, 
    //     isReconciliated: boolean | null, // null = Tout, false = Non lettré
    //     number?: string, 
    //     customerAccountId?: number,
    //     groupId?: number | null
    //   ): Observable<any[]> {
          
    //       // URL de base
    //       let url = `${environment.crmTest}/statement/entries?customerId=${customerId}&from=${from}&to=${to}`;
      
    //       // Ajout des filtres optionnels
    //       if (isReconciliated !== null) {
    //          url += `&isReconciliated=${isReconciliated}`;
    //       }
    //       if (number) {
    //          url += `&number=${number}`;
    //       }
    //       if (customerAccountId) {
    //          url += `&customerAccountId=${customerAccountId}`;
    //       }
    //       if (groupId) {
    //          url += `&groupId=${groupId}`;
    //       }
          
    //       return this.http.get<any[]>(url);
    //   }

   

    //https://crmapi.valeriahotels.com/api/statement/entries?from=2026-01-01T00:00:00&to=2026-12-31T23:59:59&customerId=572993&isReconciliated=false&customerAccountId=42&groupId=1


    getStatementEntries(filters: StatementFilters): Observable<any[]> {
        let params = new HttpParams()
          .set('from', filters.from)
          .set('to', filters.to)
          .set('customerId', filters.customerId.toString())
          .set('customerAccountId', filters.customerAccountId.toString())
          .set('groupId', filters.groupId.toString());
    
        // ERROR FIX 1: Convert boolean to string explicitly
        if (filters.isReconciliated !== null && filters.isReconciliated !== undefined) {
          params = params.set('isReconciliated', String(filters.isReconciliated));
        }
    
        if (filters.number) {
          params = params.set('number', filters.number);
        }
    
        // Adjust the API URL if needed based on your environment config
        return this.http.get<any[]>(`https://crmapi.valeriahotels.com/api/statement/entries`, { params });
      }

    //  reconcileAccountEntries(payload: NewReconciliationPayload): Observable<AccountEntryDto[]> {
    //     return this.http.post<AccountEntryDto[]>(
    //         `${environment.crmTest}/accountentry/reconcile`,
    //         payload
    //     );
    //  }
    
      /**
       * DELETE Total Reconciliation (Unmatching)
       */
    //   unreconcileAccountEntries(accountingEntryIds: number[]): Observable<AccountEntryDto[]> {
    //     return this.http.post<AccountEntryDto[]>(
    //         `${environment.crmTest}/accountentry/unreconcile`,
    //         accountingEntryIds
    //     );
    //   }


    // searchAccountEntries(paramsData: AccountEntrySearchParams): Observable<AccountEntryDto[]> {
    // let params = new HttpParams()
    //     .set('accountLogId', paramsData.accountLogId.toString())
    //     .set('from', paramsData.from)
    //     .set('to', paramsData.to)
    //     .set('debitOrCredit', paramsData.debitOrCredit);

    // if (paramsData.reference) {
    //     params = params.set('reference', paramsData.reference);
    // }

    // return this.http.get<AccountEntryDto[]>(
    //     `${environment.crmTest}/accountentry/search`,
    //     { params }
    // );
    // }

//     searchAccountEntries(paramsData: AccountEntrySearchParams): Observable<AccountEntryDto[]> {
//         let params = new HttpParams()
//             .set('accountLogId', paramsData.accountLogId.toString())
//             .set('from', paramsData.from)
//             .set('to', paramsData.to)
//             .set('debitOrCredit', paramsData.debitOrCredit);

//         if (paramsData.reference) {
//             params = params.set('reference', paramsData.reference);
//         }

//         return this.http.get<AccountEntryDto[]>(
//             `${environment.crmTest}/accountentry/search`,
//             { params }
//         );
//    }

//         reconcileAccountEntries(payload: NewReconciliationPayload): Observable<any> {
//         return this.http.post<any>(
//             `${environment.crmTest}/accountentry/reconcile`,
//             payload
//         );
//         }

//         unreconcileAccountEntries(accountingEntryIds: number[]): Observable<any> {
//         return this.http.post<any>(
//             `${environment.crmTest}/accountentry/unreconcile`,
//             accountingEntryIds
//         );
//         }

  

// getKpiByUser(fromDate: string, toDate: string, segmentId: any, groupId: number): Observable<any[]> {
//     let params = new HttpParams()
//       .set('from', fromDate)
//       .set('to', toDate)
//       .set('group', groupId.toString());

//     if (segmentId !== null && segmentId !== undefined && segmentId !== '') {
//       params = params.set('segmentid', segmentId.toString());
//     }

//     const url = `https://crmapi.valeriahotels.com/api/dashboard/reservations/kpi/by-user`;
//     return this.http.get<any[]>(url, { params });
//   }


getKpiByUser(fromDate: string, toDate: string, segmentId?: any, groupId?: number | null, userIds?: string | null): Observable<any[]> {
    let params = new HttpParams()
      .set('from', fromDate)
      .set('to', toDate);

    // Si le groupe est défini, on l'ajoute
    if (groupId) {
      params = params.set('group', groupId.toString());
    }

    // Si le segment est défini, on l'ajoute
    if (segmentId !== null && segmentId !== undefined && segmentId !== '') {
      params = params.set('segmentid', segmentId.toString());
    }

    // 🌟 NOUVEAU : Si vous passez une liste d'utilisateurs (ex: "539,603,604")
    if (userIds) {
      params = params.set('userids', userIds);
    }

    const url = `https://crmapi.valeriahotels.com/api/dashboard/reservations/kpi/by-user`;
    return this.http.get<any[]>(url, { params });
  }

  getCustomerOverview(fromDate: string, toDate: string, groupId: number): Observable<CustomerOverview> {
    const params = new HttpParams()
      .set('from', fromDate)
      .set('to', toDate)
      .set('group', groupId.toString());

    const url = `https://crmapi.valeriahotels.com/api/dashboard/customers/overview`;
    return this.http.get<CustomerOverview>(url, { params });
  }

  getReceptionPlanning(fromDate: string, toDate: string, groupId: number): Observable<ReceptionPlanning> {
    const params = new HttpParams()
      .set('from', fromDate)
      .set('to', toDate)
      .set('group', groupId.toString());

    const url = `https://crmapi.valeriahotels.com/api/dashboard/reservations/reception-planning`;
    return this.http.get<ReceptionPlanning>(url, { params });
  }

  searchAccountLogs(name: string): Observable<any> {
    return this.http.get(`https://crmapi.valeriahotels.com/api/accountlogs?name=${name}`);
  }

//   getAccountsWithDefaultLog() {
//     return this.http.get<any>('https://crmapi.valeriahotels.com/api/accounts/with-default-log');
//   }






  getAccountsWithDefaultLog() {
    return this.http.get<any>('https://crmapi.valeriahotels.com/api/accounts/with-default-log');
  }



  // =========================================================
// GL / RECONCILIATION - NEW ACCOUNT ENTRY SERVICES
// =========================================================

searchAccountEntries(paramsData: AccountEntrySearchParams): Observable<AccountEntryDto[]> {
  let params = new HttpParams()
    .set('accountLogId', paramsData.accountLogId.toString())
    .set('from', paramsData.from)
    .set('to', paramsData.to)
    .set('debitOrCredit', paramsData.debitOrCredit);

  // ✅ reference is optional — only added if provided and non-empty
  if (paramsData.reference && paramsData.reference.trim() !== '') {
    params = params.set('reference', paramsData.reference.trim());
  }

  return this.http.get<AccountEntryDto[]>(
    `${environment.crmTest}/accountentry/search`,
    { params }
  );
}

reconcileAccountEntries(payload: NewReconciliationPayload): Observable<any> {
  return this.http.post<any>(
    `${environment.crmTest}/accountentry/reconcile`,
    payload
  );
}

unreconcileAccountEntries(accountingEntryIds: number[]): Observable<any> {
  return this.http.post<any>(
    `${environment.crmTest}/accountentry/unreconcile`,
    accountingEntryIds
  );
}
  

}
    

